// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"490":"b3c2121d","842":"446f5b6b"}[chunkId] + ".chunk.js";
};